import React from 'react';
import { Box } from '@mui/material';

interface RoundContainerProps {
    children: React.ReactNode;
    padding?: string;
    backgroundColor?: string;
}

const RoundContainer: React.FC<RoundContainerProps> = ({
    children,
    padding = '16px',
    backgroundColor = '#fff',
}) => {
    return (
        <Box
            sx={{
                borderRadius: '50%',
                padding: padding,
                backgroundColor: backgroundColor,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            {children}
        </Box>
    );
};

export default RoundContainer;